import React, { ReactNode } from 'react';
import {
  CONTRACT_TEMPLATE_UPDATED,
  MARKETS_UPDATED,
  SetupArea, SetupAreaVersion,
  useSetupAreasAdminService
} from 'nekst-api';
import { useParams } from 'react-router-dom';
import { useDataLoaderNew } from 'data-loader';
import { LoadingAnimation, ShowContext, useShowContext, useShowContextRequired } from 'ui-builder';

type SetupAreaContextType = {
  setupArea: SetupArea,
  setupAreaVersion: SetupAreaVersion,
}

export function useSetupAreaVersionContext(): SetupAreaContextType | null {
  const context = useShowContext<SetupAreaContextType>();

  if (context && context.data) {
    return context.data;
  } else {
    return null;
  }
}

export function useSetupAreaVersionContextRequired(): SetupAreaContextType {
  const context = useShowContextRequired<SetupAreaContextType>();
  if (!context) {
    throw new Error('useMarketContextRequired must be used within a MarketProvider');
  }

  return context.data;
}

export function SetupAreaVersionContext(
  props: {
    children: ReactNode,
  }
) {
  const { setupAreaId: setupAreaIdString, setupAreaVersion } = useParams<{
    setupAreaId: string,
    setupAreaVersion: string
  }>();

  const setupAreaId = parseInt(setupAreaIdString!, 10);

  const setupAreaAdminService = useSetupAreasAdminService();

  const { data: setupArea } = useDataLoaderNew(
    async () => setupAreaAdminService.getSetupAreaById(setupAreaId),
    {
      events: [CONTRACT_TEMPLATE_UPDATED, MARKETS_UPDATED],
      dependencies: [setupAreaId],
    }
  );


  if (setupArea) {
    const versionObj = setupArea.versions.find((item) => item.version === setupAreaVersion);

    if (versionObj) {
      return (
        <ShowContext data={{
          setupArea,
          setupAreaVersion: versionObj,
        }}>
          {props.children}
        </ShowContext>
      );
    } else {
      return (
        <LoadingAnimation />
      );
    }
  } else {
    return (<LoadingAnimation />);
  }
}
